import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Subscription } from 'rxjs';

import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/app.state';
import { TaskListFetch } from 'src/app/workspaces/store/task-list.feature';
import { TaskDetailsDialogComponent } from './task-details-dialog.component';
import { getAllPathParams } from '@workspaces/utils/get-all-path-params';

@Component({
  selector: 'app-task-details-dialog-route',
  template: '',
  standalone: true,
  imports: []
})
export class TaskDetailsDialogRouteComponent implements OnInit, OnDestroy {
  private readonly sub = new Subscription();
  private currentRouteParams: Record<string, string> = {};
  constructor(
    private readonly dialog: MatDialog,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly store: Store<AppState>
  ) {}
  ngOnInit(): void {
    this.currentRouteParams = getAllPathParams(this.route.snapshot);

    if (!this.currentRouteParams['taskId'] || !this.currentRouteParams['workspaceId']) {
      this.router.navigate(['.', { outlets: { 'task-details': null } }], { relativeTo: this.route });
      return;
    }
    const dialogRef = this.dialog.open(TaskDetailsDialogComponent, {
      width: TaskDetailsDialogComponent.width,
      data: { taskId: this.currentRouteParams['taskId'], workspaceId: this.currentRouteParams['workspaceId'] }
    });

    this.sub.add(
      dialogRef.afterClosed().subscribe(() => {
        this.closeSubRoute();
      })
    );

    this.sub.add(
      dialogRef.backdropClick().subscribe(() => {
        this.closeSubRoute();
      })
    );
  }

  closeSubRoute() {
    this.router.navigate([{ outlets: { 'task-details': null } }], {
      relativeTo: this.route.parent,
      queryParamsHandling: 'preserve'
    });
    if (!this.currentRouteParams['workspaceId']) {
      return;
    }
    this.store.dispatch(TaskListFetch({ workspaceId: this.currentRouteParams['workspaceId'] }));
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
